"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.protoEncodeTxBody = void 0;
var long_1 = __importDefault(require("long"));
var bytes_1 = require("../../bytes/bytes");
var codec_1 = require("../../../cosmos/v1beta1/codec");
var typeurls_1 = require("../../../cosmos/v1beta1/types/typeurls");
exports.protoEncodeTxBody = function (txBody) {
    var wrappedMessages = txBody.value.messages.map(function (message) {
        var rawMessage = message.toRawMsg();
        var messageBytes = protoEncodeTxBodyMessage(rawMessage);
        return codec_1.google.protobuf.Any.create({
            type_url: rawMessage.typeUrl,
            value: messageBytes,
        });
    });
    var txBodyProto = codec_1.cosmos.tx.v1beta1.TxBody.create(__assign(__assign({}, txBody), { messages: wrappedMessages }));
    if (txBody.value.memo) {
        txBodyProto.memo = txBody.value.memo;
    }
    if (txBody.value.timeoutHeight && txBody.value.timeoutHeight !== '0') {
        txBodyProto.timeoutHeight = long_1.default.fromString(txBody.value.timeoutHeight, true);
    }
    return bytes_1.Bytes.fromUint8Array(codec_1.cosmos.tx.v1beta1.TxBody.encode(txBodyProto).finish());
};
var protoEncodeTxBodyMessage = function (message) {
    var type = typeurls_1.typeUrlMappings[message.typeUrl];
    if (!type) {
        throw new Error("Unrecognized message type " + message.typeUrl);
    }
    var created = type.create(message.value);
    return Uint8Array.from(type.encode(created).finish());
};
//# sourceMappingURL=txBodyMessage.js.map